import React from 'react';
import { useI18n } from 'react-simple-i18n';
import { Link } from 'react-router-dom';
import appstate from '../appstate';

export default function FooterComponent() {
	const { t } = useI18n();

	const asciiBullet = String.fromCharCode(8226);

	const setLanguage = (lang: string) => {
		if (localStorage.getItem('language') !== lang) {
			window.location.replace(
				window.location.origin +
					window.location.pathname +
					'?lang=' +
					lang,
			);
		}
	};

	return (
		<div className={'bg-white'}>
			<div
				className={
					'w-full max-w-8xl px-6 md:px-12 bg-white mx-auto py-8 mt-8 flex flex-col items-start text-left text-xs group transition duration-150'
				}
			>
				<div className={'text-left font-bold group-hover:opacity-100'}>
					{t('footer.top')}
				</div>
				<div className={'text-left my-5 group-hover:opacity-100'}>
					{t('footer.middle')}
				</div>
				<div
					className={
						'flex flex-col lg:flex-row gap-4 text-left group-hover:opacity-100'
					}
				>
					<div>{t('footer.bottom')}</div>
					<div className={'hidden lg:block'}> {asciiBullet} </div>
					<div>
						<Link
							to={appstate.routes().rights.path}
							className={'hover:underline'}
						>
							{t('footer.links.rights')}
						</Link>
					</div>
					<div>
						<Link
							to={appstate.routes().termsOfUse.path}
							className={'hover:underline'}
						>
							{t('footer.links.termsOfUse')}
						</Link>
					</div>
					<div>
						<Link
							to={appstate.routes().contact.path}
							className={'hover:underline'}
						>
							{t('footer.links.contact')}
						</Link>
					</div>
					<div className={'hidden lg:block'}> {asciiBullet} </div>
					<div className={'flex flex-row gap-4'}>
						<div
							className={
								'cursor-pointer inline-flex md:block hover:underline'
							}
							onClick={() => {
								setLanguage('enUK');
							}}
						>
							EN
						</div>
						<div className={'block md:hidden'}> {asciiBullet} </div>
						<div
							className={
								'cursor-pointer  inline-flex md:block  hover:underline'
							}
							onClick={() => {
								setLanguage('slSI');
							}}
						>
							SL
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
